import { ContentIcon } from './icons/ContentIcon';
import { CrossJoin } from './icons/CrossJoinIcon';
import { CurrentStatus } from './icons/CurrentStatusIcon';
import { DefaultStatus } from './icons/DefaultStatusIcon';
import { ErrorStatus } from './icons/ErrorStatusIcon';
import { FullOuterJoin } from './icons/FullOuterJoinIcon';
import { GenericJoin } from './icons/GenericJoinIcon';
import { InnerJoin } from './icons/InnerJoinIcon';
import { InterimLazy } from './icons/InterimLazyIcon';
import { InterimNormal } from './icons/InterimNormalIcon';
import { InterimStale } from './icons/InterimStaleIcon';
import { LeftOuterJoin } from './icons/LeftOuterJoinIcon';
import { NaturalJoinA } from './icons/NaturalJoinAIcon';
import { NaturalJoinB } from './icons/NaturalJoinBIcon';
import { RightOuterJoin } from './icons/RightOuterJoinIcon';
import { SuccessStatus } from './icons/SuccessStatusIcon';
import { Vector } from './icons/VectorIcon';
export const CrossJoinIcon = CrossJoin;
export const FullOuterJoinIcon = FullOuterJoin;
export const GenericJoinIcon = GenericJoin;
export const InnerJoinIcon = InnerJoin;
export const LeftOuterJoinIcon = LeftOuterJoin;
export const NaturalJoinAIcon = NaturalJoinA;
export const NaturalJoinBIcon = NaturalJoinB;
export const RightOuterJoinIcon = RightOuterJoin;
// createIcons() is must here, Used in Radio component
export { ContentIcon };
export const DefaultStatusIcon = DefaultStatus;
export const ErrorStatusIcon = ErrorStatus;
export const CurrentStatusIcon = CurrentStatus;
export const SuccessStatusIcon = SuccessStatus;
export const InterimNormalIcon = InterimNormal;
export const InterimLazyIcon = InterimLazy;
export const InterimStaleIcon = InterimStale;
export const VectorIcon = Vector;
